import type { DatasourceKind } from "./visibleDatasources";

export interface DatasourceBrowserRoute {
    path: string;
    searchFrom: string;
    storageKey: string;
    requireIndex: boolean;
}

export const DATASOURCE_BROWSER_ROUTES: Record<DatasourceKind, DatasourceBrowserRoute> = {
    document: {
        path: "/documents",
        searchFrom: "/_layout-nosidebar/documents",
        storageKey: "selectedIndex",
        requireIndex: false,
    },
    asset: {
        path: "/assets",
        searchFrom: "/_layout-nosidebar/assets",
        storageKey: "selectedAssetIndex",
        requireIndex: false,
    },
};
